export default "__VITE_ASSET__8f32d7d5__"